<mat-form-field class="w-100 arc-v2" [color]="color" [floatLabel]="floatLabel" >

    <mat-label>{{ label|translate }}</mat-label>
    <input
            name="filterSearch"
            type="text"
            id="filterSearch"
            placeholder="{{ placeholder|translate }}"
            matInput

            [(ngModel)]="search"
            (ngModelChange)="onChangeResearch()"
    >
    <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

